// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Random: MarkdocTagRegistration = {
  tag: 'random',
  component: 'Random',
  selfClosing: true,
  attributes: {
    alphabet: {type: String},
    length: {type: Number, required: true},
  },
};
